<template>
  <div>
    <div class="text-weight-bold">Sistema</div>
    <q-select
      v-model="sistema"
      :options="listaSistemas"
      @filter="filterFn"
      @input-value="setModel"
      use-input
      dense
      outlined
      option-label="sistema"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-italic text-grey">
            Nenhum sistema encontrado
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script setup>
import { ref, defineEmits, watch, defineProps } from "vue";
import { useStore } from "vuex";

const emit = defineEmits(["enviarSistema"]);
const props = defineProps(["model", "reset"]);
const time = ref();
const store = useStore();

const sistema = ref(props.model);
const listaSistemas = ref([]);

const listarSistemas = async (val) => {
  try {
    const response = await store.dispatch("office/listarSistemasIntegracoes");
    listaSistemas.value = response.data.resultado.dados.filter((sistema) => {
      return sistema.sistema.includes(val);
    });
  } catch (error) {
    console.log(error);
  }
};

watch(
  () => sistema.value,
  () => {
    if (sistema.value != "") {
      emit("enviarSistema", sistema.value);
    }
  }
);

watch(
  () => props.model,
  () => {
    sistema.value = props.model;
  }
);

watch(
  () => props.reset,
  () => {
    sistema.value = "";
  }
);

function filterFn(val, update) {
  clearTimeout(time.value);

  time.value = setTimeout(() => {
    listarSistemas(val);
  }, 2000);

  setTimeout(() => {
    update();
  }, 2500);
}

function setModel(val) {
  if (val === "") {
    sistema.value = val;
  }
}
</script>
